const STORAGE_KEY = 'word_game_sound_enabled'

let audioCtx = null

export function isGameSoundEnabled () {
  try {
    const v = localStorage.getItem(STORAGE_KEY)
    return v === null ? true : v === '1'
  } catch (e) {
    return true
  }
}

export function setGameSoundEnabled (enabled) {
  try {
    localStorage.setItem(STORAGE_KEY, enabled ? '1' : '0')
  } catch (e) { /* ignore */ }
}

export function toggleGameSound () {
  const next = !isGameSoundEnabled()
  setGameSoundEnabled(next)
  return next
}

function getAudioContext () {
  if (audioCtx) return audioCtx
  const AC = window.AudioContext || window.webkitAudioContext
  if (!AC) return null
  audioCtx = new AC()
  return audioCtx
}

async function ensureContext () {
  const ctx = getAudioContext()
  if (!ctx) return null
  if (ctx.state === 'suspended') {
    try {
      await ctx.resume()
    } catch (e) { /* ignore */ }
  }
  return ctx
}

function playTone (ctx, freq, start, duration, type, volume) {
  const osc = ctx.createOscillator()
  const gain = ctx.createGain()
  osc.type = type
  osc.frequency.setValueAtTime(freq, start)
  gain.gain.setValueAtTime(0.0001, start)
  gain.gain.exponentialRampToValueAtTime(volume, start + 0.02)
  gain.gain.exponentialRampToValueAtTime(0.0001, start + duration)
  osc.connect(gain)
  gain.connect(ctx.destination)
  osc.start(start)
  osc.stop(start + duration + 0.05)
}

export async function playGameCorrect () {
  if (!isGameSoundEnabled()) return
  const ctx = await ensureContext()
  if (!ctx) return
  const t = ctx.currentTime
  playTone(ctx, 523.25, t, 0.1, 'sine', 0.22)
  playTone(ctx, 659.25, t + 0.09, 0.12, 'sine', 0.2)
  playTone(ctx, 783.99, t + 0.18, 0.18, 'sine', 0.18)
}

export async function playGameWrong () {
  if (!isGameSoundEnabled()) return
  const ctx = await ensureContext()
  if (!ctx) return
  const t = ctx.currentTime
  playTone(ctx, 220, t, 0.14, 'square', 0.1)
  playTone(ctx, 165, t + 0.1, 0.2, 'sawtooth', 0.08)
}

export default {
  isEnabled: isGameSoundEnabled,
  setEnabled: setGameSoundEnabled,
  toggle: toggleGameSound,
  playCorrect: playGameCorrect,
  playWrong: playGameWrong
}



// WEBPACK FOOTER //
// ./src/utils/gameSound.js